// extracted by mini-css-extract-plugin
export default {"containerCabinet":"Cabinet_containerCabinet__-82it","titleCab":"Cabinet_titleCab__cJzVw"};